var _ = require('underscore');

/**
 * Convert a string or number to a Number with the given min value.
 * @param number {String|Number} the value to convert.
 * @param [minimumValue=0] {Number} the minimum value that the number should have (used if the number is not finite).
 * @return {Number} the number or minimumValue if it can't be converted or is less than minimumValue.
 */
function convertToNumberWithMinimum(number, minimumValue) {
  minimumValue = minimumValue || 0;
  if (!_.isNumber(number)) {
    number = Number(number);
  }
  if (!_.isFinite(number) || number < minimumValue) {
    number = minimumValue;
  }
  return number;
}

/**
 * Utility methods for Numbers.
 *
 * @class numberUtils
 * @static
 */
module.exports = {
  /**
   * Convert a string or number to a Number with the given min value.
   * @param number {String|Number} the value to convert.
   * @param [minimumValue=0] {Number} the minimum value that the number should have (used if the number is not finite).
   * @return {Number} the number or minimumValue if it can't be converted or is less than minimumValue.
   */
  convertToNumberWithMinimum: convertToNumberWithMinimum,

  /**
   * Takes a zero based string or Number and returns a guaranteed Number that is >= 1.
   * @method convertZeroToOneBased
   * @param zeroBasedValue {Number|String} the zero-based value to convert.
   * @return {Number} a value that is >= 1.  If the zero-based input is not a number or less than 0, then 1 is returned.
   */
  convertZeroToOneBased: function(zeroBasedValue) {
    zeroBasedValue = convertToNumberWithMinimum(zeroBasedValue, 0);
    return zeroBasedValue + 1;
  },

  /**
   * Takes a one based string or Number and returns a guaranteed Number that is >= 0.
   * @method convertOneToZeroBased
   * @param oneBasedValue {Number|String} the one-based value to convert.
   * @return {Number} a value that is >= 0.  If the one-based input is not a number or less than 1, then 0 is returned.
   */
  convertOneToZeroBased: function(oneBasedValue) {
    oneBasedValue = convertToNumberWithMinimum(oneBasedValue, 1);
    return oneBasedValue - 1;
  }

};
